module.exports = __webpack_public_path__ + "static/img/首页loading.de0659ed.png";